const isApp = (app) => {
  return typeof app === 'function';
};

export default isApp;
